import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function StatusWarningIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <>
        <path d="M12 15a1.125 1.125 0 1 1 0 2.25A1.125 1.125 0 0 1 12 15M12 7a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1" />
        <path
          fillRule="evenodd"
          d="M11.223 2.063a5 5 0 0 1 1.553 0c1.301.204 2.288 1.06 3.216 2.238.925 1.175 1.931 2.858 3.208 4.987 1.342 2.239 2.4 4 3.027 5.43.626 1.428.926 2.75.453 4.023-.185.5-.45.967-.783 1.383-.848 1.06-2.137 1.483-3.683 1.68C16.666 22.003 14.61 22 12 22s-4.666.002-6.214-.195c-1.547-.198-2.835-.62-3.684-1.68a5 5 0 0 1-.783-1.384c-.473-1.273-.173-2.595.453-4.023.627-1.43 1.685-3.191 3.027-5.43 1.277-2.13 2.283-3.812 3.208-4.987.928-1.178 1.915-2.034 3.216-2.238m1.242 1.975a3 3 0 0 0-.931 0c-.547.086-1.13.452-1.955 1.5-.828 1.051-1.759 2.6-3.065 4.778-1.371 2.288-2.347 3.921-2.91 5.205s-.606 1.995-.41 2.524c.111.3.27.58.47.83.352.44.984.768 2.376.945 1.39.178 3.293.18 5.96.18s4.57-.002 5.96-.18c1.392-.177 2.023-.505 2.376-.945.2-.25.359-.53.47-.83.197-.529.152-1.239-.41-2.524-.564-1.284-1.54-2.917-2.911-5.205-1.306-2.177-2.237-3.727-3.064-4.778-.826-1.048-1.409-1.414-1.956-1.5"
          clipRule="evenodd"
        />
      </>
    </Icon>
  );
}

StatusWarningIcon.displayName = 'StatusWarningIcon';
